import { groq, useSanityQuery } from './useSanityQuery';
import type { HomeDeliverySettings } from '../useHomeDeliveryEstimate';

export default async function () {
    const settingsQuery = groq`*[_type == "siteConfig"]{
        ...,
      mainNav[] {
      ...,
      "slug": url,
      "title": title,
      "page": *[_type == "page" && _id == ^._ref][0] {
        title,
        "slug": slug.current,
      }
    },
    showSalePercentage
    }
    `;

    interface SiteConfig {
        showSalePercentage?: boolean;
        homeDelivery?: HomeDeliverySettings;
    }

    interface SiteSettings extends SiteConfig {}

    const { data: settings } = await useSanityQuery<SiteSettings[]>(settingsQuery);

    let settingsData = settings.value;

    return settingsData;
}
